module.exports = __webpack_public_path__ + "img/p2.63772f0c.png";